import SDIcon from './SDIcon'

const IconCarbonScript = (props) => (
  <SDIcon title='DevTools' {...props}>
    <polygon points='18.83 26 21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26' />
    <polygon points='27.17 26 24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26' />
    <path d='M14,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h6ZM18,4.4,23.6,10H18Z' />
  </SDIcon>
)

export default IconCarbonScript
